/* eslint-disable react/no-array-index-key */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import {
  Building2,
  Users,
  Award,
  TrendingUp,
  FileText,
  UserCheck,
  Calendar,
  Mail,
  FolderOpen,
  BarChart3,
  Building,
  Gavel,
} from 'lucide-react';

type AiAgentQuickActionsProps = {
  onClickAction: (entity: string) => void; // eslint-disable-line no-unused-vars
};

const AiAgentQuickActions: FC<AiAgentQuickActionsProps> = ({
  onClickAction,
}) => {
  const { t } = useTranslate();

  const quickActions = [
    {
      icon: Building2,
      label: t('Society'),
      entity: 'society',
    },
    {
      icon: Users,
      label: t('Partners'),
      entity: 'partners',
    },
    {
      icon: Award,
      label: t('Beneficiaries'),
      entity: 'beneficiaries',
    },
    {
      icon: TrendingUp,
      label: t('Investors'),
      entity: 'investors',
    },
    {
      icon: FileText,
      label: t('Operations'),
      entity: 'operations',
    },
    {
      icon: Calendar,
      label: t('Boards'),
      entity: 'boards',
    },
    {
      icon: Mail,
      label: t('Communications'),
      entity: 'communications',
    },
    {
      icon: FolderOpen,
      label: t('Documents'),
      entity: 'documents',
    },
    {
      icon: UserCheck,
      label: t('Employees'),
      entity: 'employees',
    },
    {
      icon: BarChart3,
      label: t('StockPlans'),
      entity: 'stockPlans',
    },
    {
      icon: Gavel,
      label: t('TenderOffers'),
      entity: 'tenderOffers',
    },
    {
      icon: Building,
      label: t('Shares'),
      entity: 'shares',
    },
  ];

  return (
    <div className="quick-actions">
      {quickActions.map((action, index) => (
        <button
          type="button"
          key={`ai-quick-action-${index}`}
          className="btn btn-outline"
          onClick={() => onClickAction(action.entity)}
        >
          <action.icon className="mr-2" />
          {action.label}
        </button>
      ))}
    </div>
  );
};

export default AiAgentQuickActions;
